import { useState } from "react";
import { X } from "lucide-react";
import { mediaUrl } from "@/lib/site";
import { DropZone } from "./DropZone";

export const move = (arr, from, to) => {
  const next = [...arr];
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
};

export const ImageList = ({ value, onChange, testid, markFirst = false, cols = "grid-cols-3 sm:grid-cols-4 lg:grid-cols-6" }) => {
  const [drag, setDrag] = useState(null);
  return (
    <div data-testid={testid} className={`grid ${cols} gap-3`}>
      {value.map((u, i) => (
        <div key={u + i} draggable
          onDragStart={() => setDrag(i)}
          onDragOver={(e) => { if (drag !== null) e.preventDefault(); }}
          onDrop={(e) => { if (drag === null) return; e.preventDefault(); onChange(move(value, drag, i)); setDrag(null); }}
          onDragEnd={() => setDrag(null)}
          className={`group relative aspect-[3/4] overflow-hidden border cursor-grab active:cursor-grabbing ${drag === i ? "border-white opacity-50" : "border-[var(--line)]"}`}>
          <img src={mediaUrl(u)} alt="" className="w-full h-full object-cover pointer-events-none" />
          <span className="absolute top-1 left-1 font-mono text-[10px] bg-black/80 px-1.5">{markFirst && i === 0 ? "MAIN" : i + 1}</span>
          <button type="button" onClick={() => onChange(value.filter((_, j) => j !== i))} aria-label="Remove photo"
            data-testid={`${testid}-remove-${i}`}
            className="absolute top-1 right-1 bg-black/80 p-1 hover:bg-red-600 transition-colors"><X className="w-3.5 h-3.5" /></button>
        </div>
      ))}
      <DropZone multiple testid={`${testid}-add`} className="aspect-[3/4]" onUrls={(urls) => onChange([...value, ...urls])} />
    </div>
  );
};

export const ImageSlot = ({ slot, value, fallback, onChange }) => (
  <div data-testid={`slot-${slot.key}`} className="border border-[var(--line)] bg-[var(--ink-2)] p-4">
    <div className="flex items-center justify-between gap-3 mb-3">
      <p className="font-mono text-xs uppercase tracking-[0.15em]">{slot.label}</p>
      {value?.length > 0 && (
        <button type="button" onClick={() => onChange([])} data-testid={`slot-${slot.key}-reset`}
          className="font-mono text-[10px] uppercase tracking-[0.15em] text-[var(--muted)] hover:text-white">Reset</button>
      )}
    </div>
    {slot.hint && <p className="text-xs text-[var(--muted)] mb-3">{slot.hint}</p>}
    {slot.multi ? (
      <ImageList value={value?.length ? value : fallback} onChange={onChange} testid={`slot-${slot.key}-list`} />
    ) : (
      <DropZone testid={`slot-${slot.key}-drop`} className="aspect-[4/3] overflow-hidden" onUrls={(urls) => onChange(urls.slice(0, 1))}>
        <img src={mediaUrl(value?.[0] || fallback[0])} alt="" className="w-full h-full object-cover" />
        <span className="absolute bottom-0 inset-x-0 bg-black/75 py-2 text-center font-mono text-[10px] uppercase tracking-[0.2em]">Drop new photo or click</span>
      </DropZone>
    )}
  </div>
);
